import { AITissueModel } from 'components/AITools/models/AITissueModel';

export class AISegmentationModel extends AITissueModel {
  getModelOpacity() {
    return super.getOpacity().segmentation;
  }
}
